import { GearIcon } from '@radix-ui/react-icons'
import { BottomOverlayMenuButton } from 'features/overview'
import React, { Dispatch, FC, MouseEvent, SetStateAction } from 'react'
import styled from 'styled-components'
import { Vector2 } from 'three'

const StyledGearIcon = styled(GearIcon)`
  width: 32px;
  height: 32px;
  padding: 3px;
  margin-left: -4px;
`

interface EditSiteConfigButtonProps {
  closeMenu: () => void
  setShowEditSiteConfigPopupMenu: Dispatch<SetStateAction<Vector2 | undefined>>
}

export const EditSiteConfigButton: FC<EditSiteConfigButtonProps> = (props) => {
  return (
    <BottomOverlayMenuButton
      onClick={(e: MouseEvent) => {
        props.setShowEditSiteConfigPopupMenu(new Vector2(e.clientX, e.clientY))
        props.closeMenu()
      }}>
      <StyledGearIcon />
      <span>Edit Site Config</span>
    </BottomOverlayMenuButton>
  )
}
